<template>
    <div>
        <div>
            <img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicadama/5.png" style="width: 100%" alt="">
        </div>
       <product-function/>
        <product-info productInfo="cicadaMAProductInfo" productProvince="cicadaMAProvince"/>
        <div class="index-div-content  product-info-div-no-padding">
            <el-row type="flex" justify="center" class="margin-top-20 background-white product-info-div-flex">
                <el-col :xs="24" :sm="12"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicadama/3.png" style="width:100%" alt=""></el-col>
                <el-col :xs="24" :sm="12">
                    <div class="padding-40">
                        <h3 class="margin-bottom-20 margin-top-20  color-1B1B1B font-28 ">
                            <span>云台舵机摄像头水平垂直设计</span>
                        </h3>
                        <div class="robot-info-splice"></div>
                        <p class="margin-top-20">
                            机器人云台采用水平和垂直一体化设计，可以灵活调整焦距视距，拓宽数据采集视野范围，提高作业效率。
                        </p>
                    </div>

                </el-col>
            </el-row>
            <el-row type="flex" justify="center" class="margin-top-20 background-white product-info-div-flex">
                <el-col :xs="24" :sm="0"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicadama/4.png" style="width:100%" alt=""></el-col>
                <el-col :xs="24" :sm="12">
                    <div class="padding-40">
                        <h3 class="margin-bottom-20 margin-top-20  color-1B1B1B font-28 ">
                            <span>4#角钢吊轨设计，重量最轻</span>
                        </h3>
                        <div class="robot-info-splice"></div>
                        <p class="margin-top-20">
                            机器人体积320x200x200mm，体重8.5KG，使用4#角钢轨道，具有体积更小、重量更轻、性能更稳、效果更明显、成本更低等优点。
                        </p></div>
                </el-col>
                <el-col :xs="0" :sm="12"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicadama/4.png" style="width:100%" alt=""></el-col>
            </el-row>
            <el-row type="flex"  justify="center" class="margin-top-20 background-white product-info-div-flex">
                <el-col :xs="24" :sm="12"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicadama/1.png" style="width:100%" alt=""></el-col>
                <el-col :xs="24" :sm="12">
                    <div class="padding-40">
                        <h3 class="margin-bottom-20 margin-top-20  color-1B1B1B font-28 ">
                            <span>自主导航 自主定位</span>
                        </h3>
                        <div class="robot-info-splice"></div>
                        <p class="margin-top-20">
                            使用高精度电机里程计和RFID标签精准定位功能，自研底层智能导航算法技术，实现机器人全自主导航。
                        </p></div>
                </el-col>

            </el-row>
            <el-row type="flex"  justify="center" class="margin-top-20 background-white product-info-div-flex">
                <el-col :xs="24" :sm="0"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicadama/2.png" style="width:100%" alt=""></el-col>
                <el-col :xs="24" :sm="12">
                    <div class="padding-40">
                        <h3 class="margin-bottom-20 margin-top-20  color-1B1B1B font-28 ">
                            <span>自主巡检 智能巡检</span>
                        </h3>
                        <div class="robot-info-splice"></div>
                        <p class="margin-top-20">
                            底层自研多种巡检模式，包括自主巡检、排班巡检、满电巡检多种巡检模式，满足不同场景的无人巡检功能。
                        </p></div>
                </el-col>
                <el-col :xs="0" :sm="12"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicadama/2.png" style="width:100%" alt=""></el-col>
            </el-row>
        </div>
        <div class="background-white margin-top-20">
            <div  id="maodian">
                <div class="index-div-content  product-info-div-no-padding    ">

                    <h3 class="margin-bottom-10 center color-1B1B1B font-28 ">
                        <img src="../../../assets/img/1.png" width="31" alt=""> <span style="margin:0 20px">应用案例</span>
                        <img
                                src="../../../assets/img/2.png" width="31" alt="">
                    </h3>
                    <div >
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="12">
                                <div>
                                    <video-component video-url="https://MK体育 - MK(中国)一站式服务官方网站-video.oss-cn-beijing.aliyuncs.com/video/07-%E7%85%A4%E5%AE%89Cicada-%E5%8F%98%E7%94%B5%E6%89%80%E5%B7%A1%E6%A3%80-%E7%85%A4%E7%A7%91%E9%99%A2-%E9%85%B8%E5%88%BA%E6%B2%9F.mp4"/>
                                    <div class="video-content">案例1：内蒙古某变电所机器人巡检</div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <div>
                                    <video-component1 video-url="https://MK体育 - MK(中国)一站式服务官方网站-video.oss-cn-beijing.aliyuncs.com/video/06-%E6%A0%87%E5%87%86Cicada-%E8%BE%93%E7%85%A4%E5%BB%8A%E9%81%93-%E4%B8%AD%E5%AE%89%E5%90%89%E6%B3%B0-%E5%92%8C%E6%9E%97%E7%94%B5%E5%8E%82.mp4"/>
                                    <div class="video-content">案例2：内蒙古某输煤皮带机器人巡检</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div style="height: 20px">      </div>
                </div>
            </div>

        </div>

    </div>


</template>

<script>
    import VideoComponent from "../../commom/VideoComponent";
    import VideoComponent1 from "../../commom/VideoComponent";
    import ProductFunction from "../../commom/ProductFunction";
    import ProductInfo from "../../commom/ProductInfo";
    export default {
        name: "cicadama",
        components:{VideoComponent,VideoComponent1,ProductFunction,ProductInfo},
        mounted() {
            this.$nextTick(()=>{
                this.$http
                    .all([
                        this.$http.get("Cases/GetCasesAll"),
                        this.$http.get(`News?type=1&num=3`)
                    ])
                    .then(
                        this.$http.spread((responseCases, responseNews) => {
                            if(this.$route.hash){
                                let dom =  document.querySelector(this.$route.hash);
                                console.log(dom)
                                dom.scrollIntoView();
                            }

                        })
                    );


            })
        }
    }
</script>

<style scoped>

</style>